export function ItemCountLabel({ total }: { total: number }) {
  return (
    <div className='flex items-center gap-1'>
      <div className='text-body-medium text-regular'>全</div>
      <div className='text-body-large font-bold text-regular'>{total}</div>
      <div className='text-body-medium text-regular'>件</div>
    </div>
  );
}
